/*
 * @Author: your name
 * @Date: 2021-09-16 13:28:21
 * @LastEditTime: 2021-12-03 10:58:52
 * @LastEditors: DESKTOP-0USOKJQ
 * @Description: In User Settings Edit
 * @FilePath: \sp-site-front\src\store\index.js
 */
import Vue from 'vue'
import 'es6-promise/auto'
import Vuex from 'vuex'
import Cookies from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
  state(){
    return{
      token:Cookies.get('sp_token') ? Cookies.get('sp_token'):'',
      userName:Cookies.get('sp_userName') ? Cookies.get('sp_userName'):'',
      city: localStorage.getItem('city') ? JSON.parse(localStorage.getItem('city')) : '',
      province: localStorage.getItem('province') ? JSON.parse(localStorage.getItem('province')) : '',
      isMian: localStorage.getItem('isMain') == '1' ? true : false,
      count:0, //是否重新加载的标识
    }
  },
  getters: {    // 监听数据变化的
    getToken(state) {   // 获取本地存储的登录信息
      if (!state.token) {
        state.token = Cookies.get('sp_token')
      }
      return state.token
    },
    getUserName(state){
      if (!state.userName) {
        state.userName = Cookies.get('sp_userName')
      }
      return state.userName
    },
    getLastLoginCheckTime(state) {
       return localStorage.getItem('lastLoginCheckTime') - 0;
    },
    getIsMian(state){
      if (!state.isMian) {
        state.isMian = localStorage.getItem('isMain') == '1' ? true : false;
      }
      return state.isMian
    }
  },
  mutations: {
    $_setToken(state, value) { // 设置存储token
      state.token = value;
      Cookies.set('sp_token', value);
    },
    $_setUserName(state,value){
      state.userName = value;
      Cookies.set('sp_userName',value);
    },
    $_removeToken(state) {  // 删除token
      state.token = '';
      Cookies.remove('sp_token');
    },
    $_removeUserName(state){
      state.userName = '';
      Cookies.remove('sp_userName');
    },
    $_setLastLoginCheckTime(state,value){
      localStorage.setItem('lastLoginCheckTime', value);
    },
    //设置cityId
    $_setCity(state,value){
      state.city = value;
      // localStorage.setItem('city', JSON.stringify(value));
      localStorage.setItem('city', '3212');
    },
    // 设置provinceId
    $_setProvince(state,value){
      state.province = value;
      // localStorage.setItem('province', JSON.stringify(value));
      localStorage.setItem('province', '2');
    },
    $_setIsMian(state,value){
      localStorage.setItem('isMain', value);
    },
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js